
import React from 'react';
import { FormField } from '@/components/ui/form';
import IconInput from '@/components/auth/IconInput';
import { SignupFormField } from '@/utils/config/types';
import { UseFormReturn } from 'react-hook-form';
import { getFieldIcon } from '@/utils/iconUtils';

interface IconInputFieldProps {
  field: SignupFormField;
  form: UseFormReturn<any>;
}

const IconInputField = ({ field, form }: IconInputFieldProps) => {
  const Icon = getFieldIcon(field.name, field.type);
  
  return (
    <FormField
      key={field.name}
      control={form.control}
      name={field.name}
      render={({ field: formField }) => (
        <IconInput
          name={field.name}
          label={field.label}
          placeholder={`Enter your ${field.label.toLowerCase()}`}
          type={field.type}
          icon={Icon}
          field={formField}
          required={field.required}
        />
      )}
    />
  );
};

export default IconInputField;
